var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-slot',{attrs:{"title":_vm.title,"is-cancel-hide":!_vm.isClose,"cancel-text":_vm.textClose,"is-save":_vm.isApply,"apply-text":_vm.textApply,"width":_vm.width},on:{"updateClose":_vm.onClose,"updateSave":_vm.onApply}},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }